export default "__VITE_ASSET__e85090c8__"